"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var amChartList = function amChartList(list) {
  var findValueById = function findValueById(id) {
    return list.values.find(function (item) {
      return item.id === id;
    });
  };

  return {
    findValueById: findValueById
  };
};

var _default = amChartList;
exports["default"] = _default;